import { Component } from '@angular/core';
import { PeptideTherapyComponent } from '@consultation-upsells/peptide-therapy/peptide-therapy.component';

@Component({
  selector: 'app-peptide-therapy-ed',
  imports: [PeptideTherapyComponent],
  templateUrl: './peptide-therapy-ed.component.html',
})
export class PeptideTherapyEdComponent {}
